const HASHTABLE_PROFILES = [
    {
        profile: 'JEREMY',
        isDisabled: false,
    },
    {
        profile: 'ABIGAIL',
        isDisabled: false,
    },
    {
        profile: 'MARK',
        isDisabled: false,
    },
]


export const getParsedHashtableProfiles = () => {
    const parsedHashtableProfiles = localStorage.getItem('HASHTABLE_PROFILES');
    return JSON.parse(parsedHashtableProfiles as string) || HASHTABLE_PROFILES;
}

export const setHasTableProfilesStorage = async (profile: string, isDisabled: boolean) => {

    for (let i = 0; i < HASHTABLE_PROFILES.length; i++) {
        if (HASHTABLE_PROFILES[i].profile === profile ) {
            let myPromise = new Promise((resolve) => {
                resolve(HASHTABLE_PROFILES[i].isDisabled = isDisabled);
            });
            myPromise.then(() => {
                console.log('HASHTABLE_PROFILES', HASHTABLE_PROFILES)
                return localStorage.setItem('HASHTABLE_PROFILES', JSON.stringify(HASHTABLE_PROFILES));
            })
        }
    }
}